import { render, staticRenderFns } from "./harmful_detail.vue?vue&type=template&id=12637010&"
import script from "./harmful_detail.vue?vue&type=script&lang=js&"
export * from "./harmful_detail.vue?vue&type=script&lang=js&"
import style0 from "./harmful_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports